import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { Helper, parseApiResponseArray } from "@helpers/functions";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { TradableInfo } from "@modules/+new/core/tradables/domain/entities/tradable-info";

// TODO: eslint fix (Consider add to ApicallService typings to get/post methods as in Angular HttpService)
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
	providedIn: "root"
})
export class TradablesDataService {
	constructor(private http: ApicallService) {}

	public getTradableInfoByTradableId(id: string): Observable<TradableInfo> {
		const option = new ApicallOption(null, { asset_ids: [id] });

		return this.http.post("assets/info", option).pipe(
			map((response) => parseApiResponseArray<TradableInfo>(response)),
			map((infos) => infos[0]),
			catchError((error) => {
				Helper.handleError(error);
				return observableOf(null);
			})
		);
	}
}
